import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import './CompanyHistory.css';

const Products = () => {
  const [activeSection, setActiveSection] = useState('heat-exchanger');
  
  const sidebarItems = [
    { name: '판형열교환기', path: 'heat-exchanger' },
    { name: '컴팩트 설비 유니트', path: 'compact-unit' },
    { name: '순간온수가열기', path: 'heating-system' },
    { name: '브레이징 열교환기', path: 'brazing-heat-exchanger' },
    { name: '스파이럴 열교환기', path: 'spiral-heat-exchanger' },
    { name: '용접형 판형열교환기', path: 'welded-plate-heat-exchanger' },
    { name: 'GAS COOLER', path: 'gas-cooler' },
    { name: '밀폐형 팽창탱크', path: 'closed-expansion-tank' },
    { name: '팽창기수분리기', path: 'expansion-separator' },
    { name: '플레이트 코일', path: 'plate-coil' },
    { name: '볼탱크', path: 'ball-tank' },
    { name: 'ATM 탱크', path: 'atm-tank' }
  ];

  // 스크롤 스파이 기능
  useEffect(() => {
    const handleScroll = () => {
      const sections = sidebarItems.map(item => item.path);
      
      for (let i = sections.length - 1; i >= 0; i--) {
        const section = document.getElementById(sections[i]);
        if (section && section.offsetTop - 200 <= window.scrollY) {
          setActiveSection(sections[i]);
          break;
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // 해시 URL 처리 (페이지 로드 시 해당 섹션으로 이동)
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash) {
      setTimeout(() => {
        scrollToSection(hash);
      }, 50);
    }
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };

  return (
    <>
      <Sidebar 
        category="제품소개" 
        items={sidebarItems} 
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">제품소개</h1>
          
          {/* 판형열교환기 섹션 */}
          <section id="heat-exchanger" className="section">
            <h2 className="section-title">판형열교환기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>판형열교환기</h3>
              <p>판형열교환기는 전열판, 가스켓, 후레임 및 조임볼트 등의 주요 부품으로 구성됩니다. 그 중 전열판은 강한 난류를 형성시켜 높은 열교환 성능을 이끌어 내며, <br/>가스켓은 1,2차측 유체의 유로를 구성함과 동시에 Sealing의 역할을합니다.</p>
            </div>

            {/* 판형열교환기 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung.jpg" alt="판형열교환기" className="esg-image" />
                <h3 className="esg-title">판형열교환기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 전열효과가 우수 (High Efficiency)</div>
                  <div className="feature-text-item">• 컴팩트한 구조 (Compact)</div>
                  <div className="feature-text-item">• 완전 분해 조립식 (Easy Maintenance)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 다양한 유로 구성 (Versatility of Duty)</div>
                  <div className="feature-text-item">• 설치 비용이 저렴 (Economical in Cost)</div>
                  <div className="feature-text-item">• 용량증설 및 변경이 용이 (Capacity Adaptability)</div>
                </div>
              </div>
            </div>

            {/* 표준 사양 */}
            <div className="product-specs">
              <h3>▶ 사양 - Standard Specification</h3>
              <div className="specs-text-list">
                  <div className="spec-text-item">• Plate Material : SS304, SS316, SS316L, ASTM-A240M-316L, SMO254, SLX904<br/>        Titanium, Titanium-Palladium, Nickel, Nickel Alloy<br/>        Hastelloy-C, Hastelloy-B, Etc.</div>
                <div className="spec-text-item">• Gasket Material : NBR, EPDM, HNBR, Viton, Teflon, Silicon</div>
                <div className="spec-text-item">• Max. Design Pressure : 34kg/cm²</div>
                <div className="spec-text-item">• Max. Design Temperature : -30°C ~ 210°C</div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- 냉난방 공기조화 (HVAC)</div>
                <div className="application-text-item">- 식료품 및 제약품의 살균 공정 (HTST & UHT)</div>
                <div className="application-text-item">- 폐열 회수 시스템 (Heat Recovery System)</div>
                <div className="application-text-item">- 금속 공업 (Iron & Steel Industry)</div>
                <div className="application-text-item">- 화학 공업 (Chemical Industry)</div>
                <div className="application-text-item">- 해수, 강수를 이용한 Central Cooling 시설 (Central Cooling with Sea Water)</div>
                <div className="application-text-item">- 조선 공업 (Shipbuilding Industry)</div>
                <div className="application-text-item">- 냉동기, Heat Pump의 고효율 증발기 및 응축기 (Evaporator & Condenser in Chiller and Heat Pump)</div>
              </div>
            </div>

            {/* 제품규격 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung_kyukyuk.jpg" alt="판형열교환기 제품규격" className="esg-image" />
                <h3 className="esg-title">판형열교환기 제품규격</h3>
              </div>
            </div>

            {/* 사양표 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/panhyung_sayang.png" alt="판형열교환기 사양표" className="esg-image" />
                <h3 className="esg-title">판형열교환기 사양표</h3>
              </div>
            </div>
          </section>

          {/* 컴팩트 설비 유니트 섹션 */}
          <section id="compact-unit" className="section">
            <h2 className="section-title">컴팩트 설비 유니트</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>컴팩트 설비 유니트</h3>
              <p>지역난방 컴팩트 설비 유니트는 판형열교환기, 펌프, 온도조절밸브, 자동제어 등 지역난방 Sub-Station에 설치되는 장비를 열교환기 제조사에서 표준화된 모듈로 설계하고 발주처와 지역난방 공사의 승인을 득한 후 제조사 공장에서 장비 제작, 구매, 배관 공사 및 검사 등을 일괄적으로 수행하여 지역난방 사용자 기계실에 설치되는 제품입니다.</p>
            </div>

            {/* 시스템 구성도 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/compact.gif" alt="컴팩트 설비 유니트 시스템 구성도" className="esg-image" />
                <h3 className="esg-title">컴팩트 설비 유니트 시스템 구성도</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 복합형 MBS 구조 (Multi Benefit System)</div>
                  <div className="feature-text-item">  - 한국지역난방공사가 권장하는 분리형 구조의 배관</div>
                  <div className="feature-text-item">  - 설치공간은 일체형, 유지보수는 분리형인 첨단 복합형으로 가장 Compact한 배관 Lay-out을 실현합니다.</div>
                  <div className="feature-text-item">  - 기계실 활용도가 증가합니다.</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 고품질 판형열교환기 (High Quality Plate Heat Exchanger)</div>
                  <div className="feature-text-item">  - 세계정상의 전열판으로 최고 34bar의 압력에서도 운전 가능</div>
                  <div className="feature-text-item">  - 세척 및 유지보수가 간편한 Easy-Hook 가스켓 채택 (국제특허획득 : 한국, 일본, 미국, 스웨덴, 중국등)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 완벽한 품질보증시스템 (Reliable Quality Control System)</div>
                  <div className="feature-text-item">  - ISO9001 품질인증시스템을 기본으로 설계, 제작, 검사, 납품 및 시운전까지 엄격한 품질관리가 이루어 집니다.</div>
                  <div className="feature-text-item">  - 당사 공장에서 설계팀과 QA팀의 공정별 검사가 수행됩니다.</div>
                  <div className="feature-text-item">  - 24시간 A/S 시스템 구축</div>
                </div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- 지역난방공사의 중온수를 열원으로 난방 및 급탕을 사용하는 전 아파트, 상업건물 및 공공건물</div>
              </div>
            </div>

            {/* 주요 거래처 */}
            <div className="product-partners">
              <h3>▶ 주요거래처 - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- 현대건설, 현대산업개발, 대림산업, 롯데건설, 대한주택공사, GS건설, 서울시 도시개발공사, 한라건설, 벽산건설, 두산건설, 쌍용건설, 남광토건, 한화건설, SK건설 등 주요 1군 건설사</div>
              </div>
            </div>
          </section>

          {/* 순간온수 가열기 섹션 */}
          <section id="heating-system" className="section">
            <h2 className="section-title">순간온수 가열기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>순간온수 가열기</h3>
              <p>순간온수 가열기는 Steam을 열원으로 이용하여 급탕 또는 온수를 공급하고자 하는 System에 소요되는 판형열교환기, 온도조절밸브, 스팀트랩, 자동제어등을 표준화된 모듈로 설계하고 공장에서 장비구매, 제작, 배관, 검사 등을 일괄적으로 수행하여 사용자 기계실에 설치되는 제품입니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_03.gif" alt="순간온수 가열기" className="esg-image" />
                <h3 className="esg-title">순간온수 가열기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 제품의 모듈화 및 표준화</div>
                  <div className="feature-text-item">  - 모듈화된 제작품으로 공사기간 단축 및 타 공정과의 간섭이 최소화</div>
                  <div className="feature-text-item">  - 표준화되고 검증된 모듈에 의한 설계, 시공으로 품질 향상</div>
                  <div className="feature-text-item">  - 설치공간 절감으로 건축비 절감</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 고품질 판형열교환기 (High Quality Plate Heat Exchanger)</div>
                  <div className="feature-text-item">  - 세계정상의 전열판으로 최고 34bar의 압력에서도 운전 가능</div>
                  <div className="feature-text-item">  - 세척 및 유지보수가 간편한 Easy-Hook 가스켓 채택 (국제특허획득 : 한국, 일본, 미국, 스웨덴, 중국 등)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 완벽한 품질보증시스템 (Reliable Quality Control System)</div>
                  <div className="feature-text-item">  - ISO9001 품질인증시스템을 기본으로 설계, 제작, 검사, 납품 및 시운전까지 엄격한 품질관리가 이루어 집니다.</div>
                  <div className="feature-text-item">  - 당사 공장에서 설계팀과 QA팀의 공정별 검사가 수행됩니다.</div>
                  <div className="feature-text-item">  - 24시간 A/S 시스템 구축</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 자동제어, MCC, 환탕펌프 및 차단밸브 포함 </div>
                </div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Steam을 열원으로 난방 및 급탕을 사용하는 전 아파트, 상업건물 및 공공건물</div>
              </div>
            </div>

            {/* 주요 거래처 */}
            <div className="product-partners">
              <h3>▶ 주요거래처 - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- 현대건설, GS건설, 현대산업개발, 대림산업, 대한주택공사, SH공사 등 주요 1군 건설사</div>
              </div>
            </div>
          </section>

          {/* 브레이징 열교환기 섹션 */}
          <section id="brazing-heat-exchanger" className="section">
            <h2 className="section-title">브레이징 열교환기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>브레이징 열교환기</h3>
              <p>브레이징 Plate Heat Exchanger는 지금껏 발전된 열교환기중 가장 컴팩트한 형태의 열교환기중 하나입니다. 이 열교환기의 열전달 원리는 판형열교환기와 동일하나 Sealing 및 유체 분배는 판형열교환기에서의 Gasket 역할을 대신하여 Copper & Nickel welding 기술이 도입된 제품입니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_04.gif" alt="브레이징 열교환기" className="esg-image" />
                <h3 className="esg-title">브레이징 열교환기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 초소형 (Compact)</div>
                  <div className="feature-text-item">• 고효율 (High Heat Transfer performance)</div>
                  <div className="feature-text-item">• 경제성 (Economical in Cost)</div>
                </div>
              </div>
            </div>

            {/* 사양 */}
            <div className="product-specs">
              <h3>▶ 사양 - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Plate Material : Stainless Steel, Nickel</div>
                <div className="spec-text-item">• Cover Plate and Connections : Stainless Steel, Nickel</div>
                <div className="spec-text-item">• Brazing Materials : 99.9% Copper, Nickel</div>
                <div className="spec-text-item">• Design Pressure : 30kg/cm² (Vacuum)</div>
                <div className="spec-text-item">• Test Pressure : 40kg/cm²</div>
                <div className="spec-text-item">• Temperature : -195°C ~ 225°C</div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">
                  <span className="application-category-title">HVAC</span>
                  <ul className="sub-list">
                    <li>Evaporators and Condensers in Chillers and Heat Pumps</li>
                    <li>Heating Floors and Hot Water Tapping in District Heating System</li>
                    <li>Fluid Isolation of Solar Energy System</li>
                    <li>Hot Water Generators in Steam Application</li>
                  </ul>
                </div>
                <div className="application-text-item">
                  <span className="application-category-title">General Industrial Application</span>
                  <ul className="sub-list">
                    <li>Oil Cooling of Hydraulic System</li>
                    <li>Water Cooling of Molding machines, Induction Furances and Plastic Injection Machines</li>
                    <li>Heat Recovery System</li>
                    <li>Heating and Cooling in Food Processing Industries</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* 스파이럴 열교환기 섹션 */}
          <section id="spiral-heat-exchanger" className="section">
            <h2 className="section-title">스파이럴 열교환기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>스파이럴 열교환기</h3>
              <p>Spiral열교환기는 소용돌이형 또는 나선형 열교환기라고도 하며, Covers, Plain Plates, Pins
등으로 구성된 제품으로, 비교적 높은 점성의 유체, 스케일 형성이 많은 유체 및 Thermal
Length가 큰 열교환 공정에 적합합니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_06.gif" alt="스파이럴 열교환기" className="esg-image" />
                <h3 className="esg-title">스파이럴 열교환기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 비교적 고온 및 고압에 적합 (Relatively High Design Pressure & Temperature)</div>
                  <div className="feature-text-item">• 전열효과가 우수 (High Efficiency)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 자체 청정효과가 우수 (Easy Maintenance)</div>
                  <div className="feature-text-item">• 고점도 및 스케일이 많은 유체에 적용이 가능 (Application on High Viscosity & High-Fouled Liquid)</div>
                </div>
              </div>
            </div>

            {/* 표준 사양 */}
            <div className="product-specs">
              <h3>▶ 사양 - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Design Pressure : 20kg/cm²</div>
                <div className="spec-text-item">• Max. Operating Temperature : 350°C ~ 400°C</div>
                <div className="spec-text-item">• Area : 0.5 ~ 300m²</div>
                <div className="spec-text-item">• Material : 탄소강, 스테인리스스틸, 니켈합금, 티타늄 등</div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Air, Liquid to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Liquid to Liquid, Liquid to Air)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* 용접형 판형열교환기 섹션 */}
          <section id="welded-plate-heat-exchanger" className="section">
            <h2 className="section-title">용접형 판형열교환기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>용접형 판형열교환기</h3>
              <p>용접형 판형열교환기는 판형열교환기와 Shell & Tube 열교환기의 장점을 조합한 제품으로 고온, 고압에 유리하며 Shell & Tube 열교환기의 1/3~1/5의 크기로 동일한 효과를 발휘합니다.</p>
            </div>

            {/* 제품 사진들 */}
            <div className="welded-heat-exchanger-slider" style={{display: 'flex', gap: '25px', marginBottom: '30px', justifyContent: 'center', maxWidth: '1014px', margin: '0 auto 30px auto', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/product_11-2.jpg" alt="용접형 판형열교환기 구조" style={{maxHeight: '338px', maxWidth: '468px', minWidth: '100%', flex: '1'}} />
                <img src="/products/product_11.jpg" alt="용접형 판형열교환기" style={{maxHeight: '338px', maxWidth: '468px', minWidth: '100%', flex: '1'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.welded-heat-exchanger-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.welded-heat-exchanger-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 고온 및 고압에 적합 (Relarively High Design Pressure & Temperature)</div>
                  <div className="feature-text-item">• 전열효과가 우수 (High Efficiency)</div>
                  <div className="feature-text-item">• 설치공간 감소 (Low Installation Space)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 자체 청정효과가 우수 (Easy Maintenance)</div>
                  <div className="feature-text-item">• 개방형과 용접형으로 구분되어 용도에 맞게 설정이 가능하며 전열판 가스켓이 없으므로 경제적인 유지보수가 가능하다</div>
                </div>
              </div>
            </div>

            {/* 표준 사양 */}
            <div className="product-specs">
              <h3>▶ 사양 - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Desing Pressure : 150Bar(g)</div>
                <div className="spec-text-item">• Max. Operating Temperature : -200°C ~ 500°C</div>
                <div className="spec-text-item">• Area : 0.5 ~ 300m²</div>
                <div className="spec-text-item">• Material : 스테인리스스틸, 니켈합금, 티타늄 등</div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Air, Liquid to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Liquid to Liquid, Liquid to Air)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* GAS COOLER 섹션 */}
          <section id="gas-cooler" className="section">
            <h2 className="section-title">GAS COOLER</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>GROOVE TYPE FINTUBE 열교환기</h3>
              <p>GROOVE TYPE FINTUBE 열교환기는 기상과 액상의 열교환에 가장 유리한 TYPE이며 BARE TUEB에 비하여 3~5배의 효과를 발휘합니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_10.png" alt="GROOVE TYPE FINTUBE 열교환기" className="esg-image" />
                <h3 className="esg-title">GROOVE TYPE FINTUBE 열교환기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 고온 GAS(AIR)에 적합한 구조로 신축이 원활하여 온도 팽창에 따른 파손에 유리</div>
                  <div className="feature-text-item">• GROOVE TYPE FINTUBE는 150도 이상 500도 미만의 온도에서 적용가능</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 전, 후 케이스 분리가 가능하여 경제적인 유지보수 가능</div>
                </div>
              </div>
            </div>

            {/* 표준 사양 */}
            <div className="product-specs">
              <h3>▶ 사양 - Standard Specification</h3>
              <div className="specs-text-list">
                <div className="spec-text-item">• Max. Operating Desing Pressure : Tube Side 50Bar(g)</div>
                <div className="spec-text-item">• Max. Operating Temperature : -50°C ~ 500°C</div>
                <div className="spec-text-item">• Area : 2 ~ 500m²</div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Condenser & Evaporater (Gas to Liquid)</div>
                <div className="application-text-item">- Cooler & Heater (Gas to Liquid)</div>
                <div className="application-text-item">- Heat Recovery System</div>
              </div>
            </div>
          </section>

          {/* 밀폐형 팽창탱크 섹션 */}
          <section id="closed-expansion-tank" className="section">
            <h2 className="section-title">밀폐형 팽창탱크</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>밀폐형 팽창탱크</h3>
              <p>밀폐형 팽창탱크는 기존의 블래더식 팽창탱크와 공기압축식, 전자밸브, 자동제어반으로 구
성되어 기존 블래더식 팽창탱크 사용시 System 운전에 따른 압력 변동에 의해 배관 수명이
저하되고 고압에 의해 팽창탱크 효율이 저하됨을 개선할 목적으로 개발된 제품입니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_07.gif" alt="밀폐형 팽창탱크" className="esg-image" />
                <h3 className="esg-title">밀폐형 팽창탱크</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 정압 유지 기능 (Constant Pressure System)
                    <ul className="sub-list">
                      <li>우수한 배관 정압 유지 기능(±0.3bar)으로 배관 수명 연장</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 완전 밀폐식 시스템 (Completely Sealed System)
                    <ul className="sub-list">
                      <li>배관수를 외부 공기로부터 완전 차단하여 공기 유입 방지로 배관 부식 방지</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 용적율 최소화 (Minimized Volume Ratio)
                    <ul className="sub-list">
                      <li>팽창탱크의 유효 활용률을 극대화하여 탱크 전체 크기 최소화</li>
                    </ul>
                  </div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 대화방식의 완벽한 자동제어 (Perfect Automatic Control with Dialogue Method)
                    <ul className="sub-list">
                      <li>초보자도 쉽게 조작할 수 있는 완전 자동 제어반</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 완벽한 품질보증시스템 (Reliable Quality Control System)
                    <ul className="sub-list">
                      <li>ISO9001 품질인증시스템을 바탕으로 설계, 제조, 검사, 납품, 시공까지 엄격한 품질관리</li>
                      <li>공정별 검사는 본사 공장에서 설계팀과 QA팀이 담당</li>
                      <li>24시간 A/S 시스템 구축</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- 각종 열원(지역난방, 보일러, 열교환기, 냉온수기)을 사용하는 건물 및 공장의 냉난방 system</div>
              </div>
            </div>

            {/* 주요거래처 */}
            <div className="product-applications">
              <h3>▶ 주요거래처 - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">- 삼성물산, 현대건설, 현대산업개발, 대림산업, 롯데건설, 한국토지주택공사, GS건설, 금호건설, 남광토건, 두산건설 등 주요 1차 건설사</div>
              </div>
            </div>
          </section>

          {/* 팽창기수분리기 섹션 */}
          <section id="expansion-separator" className="section">
            <h2 className="section-title">팽창기수분리기</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>팽창기수분리기</h3>
              <p>팽창기수분리기는 기존의 밀폐형 팽창탱크의 역할과 Air Separator의 역할을 동시에 처리하는 획기적인 제품으로 고층건물이 주를 이루는 현실에 맞추어 압력용기 방식에서 벗어나 보급수펌프 및 전자밸브를 사용하여 탱크에 압력이 작용하지 않도록 설계, 제작하여 팽창탱크로서의 역할에 안전성을 보완하였으며, Air Separator의 기능도 첨가하여 협소한 기계실의 공간활용에도 용이한 미래지향적인 제품입니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_08.gif" alt="팽창기수분리기" className="esg-image" />
                <h3 className="esg-title">팽창기수분리기</h3>
              </div>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 정압 유지 기능 (Constant Pressure System)
                    <ul className="sub-list">
                      <li>탁월한 배관 정압유지(±0.2bar) 기능으로 배관 수명연장.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 배관수의 용존산소 및 염화물의 제거작용
                    <ul className="sub-list">
                      <li>배관 부식방지 및 스케일 방지기능.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 시공의 편리성 (Compact)
                    <ul className="sub-list">
                      <li>Compact한 설계로 현장 설치가 간단하며 기계실 공간활용이 용이합니다.</li>
                    </ul>
                  </div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 간편한 유지보수 (Easy Maintenance)
                    <ul className="sub-list">
                      <li>모든 기기가 한 곳으로 표준화되어 설치됩니다.</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 대화방식의 완벽한 자동제어
                    <ul className="sub-list">
                      <li>초보자도 쉽게 운전할 수 있는 전자동 Controller</li>
                    </ul>
                  </div>
                  <div className="feature-text-item">• 완벽한 품질보증시스템 (Reliable Quality Control System)
                    <ul className="sub-list">
                      <li>ISO9001 품질인증시스템을 기본으로 설계, 제작, 검사, 납품 및 시운전까지 엄격한 품질관리가 이루어 집니다.</li>
                      <li>당사 공장에서 설계팀과 QA팀의 공정별 검사가 수행됩니다.</li>
                      <li>24시간 A/S 시스템 구축</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">각종 열원(지역난방, 보일러, 열교환기, 냉온수기)을 사용하는 건물 및 공장의 냉난방 System.</div>
              </div>
            </div>

            {/* 주요거래처 */}
            <div className="product-applications">
              <h3>▶ 주요거래처 - Principal Customer</h3>
              <div className="partners-text-list">
                <div className="partner-text-item">삼성건설, 현대건설, 현대산업개발, 대림산업, 롯데건설, 대한주택공사, GS건설, 금호건설, 남광토건, 두산건설 등 주요 1군 건설사</div>
              </div>
            </div>

          </section>

          {/* 플레이트 코일 섹션 */}
          <section id="plate-coil" className="section">
            <h2 className="section-title">플레이트 코일</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>플레이트 코일</h3>
              <p>Plate coil은 가열과 냉각에 쓰이는 여러가지 화학탱크의 작은 열 부담을 커버하기 위해 개발되었습니다. 또한 반응, 세척, 샤워탱크에 직접 적용 가능합니다.</p>
            </div>

            {/* 제품 사진 */}
            <div className="esg-grid">
              <div className="esg-item">
                <img src="/products/product_05.gif" alt="플레이트 코일" className="esg-image" />
                <h3 className="esg-title">플레이트 코일</h3>
              </div>
            </div>

            {/* 적용 범위 */}
            <div className="product-applications">
              <h3>▶ 적용범위 - Application</h3>
              <div className="applications-text-list">
                <div className="application-text-item">- Cleaning, Degreasing, ED Process in Anodizing</div>
                <div className="application-text-item">- Pre-Treatment Facility in Painting, Metal Plating</div>
                <div className="application-text-item">- Decreasing, Hot Water Cleaning, Phosphorating and Various Chemical Tanks</div>
              </div>
            </div>
          </section>

          {/* 볼탱크 섹션 */}
          <section id="ball-tank" className="section">
            <h2 className="section-title">볼탱크</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>볼탱크 (Spherical Tank)</h3>
              <p>볼탱크(Spherical Tank)는 주로 LPG, LNG, 암모니아, 부탄 등 휘발성 및 고압 액체 저장을
목적으로 사용되며, 구형 구조로 인해 내부 압력을 균일하게 분산시키는 장점이 있습니다.
강구조 지지물과 함께 설계되며, 설계 압력과 온도에 따라 용도별 다양한 크기로 제작됩니다.</p>
            </div>

            {/* 제품 사진들 */}
            <div className="ball-tank-slider" style={{display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/balltank1.jpg" alt="볼탱크" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/balltank2.jpg" alt="볼탱크 구조" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.ball-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.ball-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 압력 분산에 유리한 구조 (Pressure Distribution Structure)</div>
                  <div className="feature-text-item">• 안전성 확보에 유리 (Safety Assurance)</div>
                  <div className="feature-text-item">• 공간 활용 효율 우수 (Space Efficiency)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 유지보수 용이 (Easy Maintenance)</div>
                  <div className="feature-text-item">• 다양한 용량 및 사용처 대응 (Various Capacity & Applications)</div>
                </div>
              </div>
            </div>
          </section>

          {/* ATM 탱크 섹션 */}
          <section id="atm-tank" className="section">
            <h2 className="section-title">ATM 탱크</h2>
            
            {/* 제품 개요 */}
            <div className="product-description">
              <h3>ATM 탱크</h3>
              <p>ATM탱크는 주로 발전소, 화학 공장, 저장 터미널 등에서 원유, 정제유, 화학제품 등의
대용량 저장을 위한 탱크로 사용됩니다. 대기압 또는 저압 조건에서 사용되며,
용도에 따라 Floating Roof, Dome Roof, Cone Roof 등의 구조로 제작됩니다.</p>
            </div>

            {/* 제품 사진들 */}
            <div className="atm-tank-slider" style={{display: 'flex', gap: '20px', marginBottom: '30px', justifyContent: 'center', overflow: 'hidden', position: 'relative'}}>
              <div className="slider-container" style={{display: 'flex', transition: 'transform 0.5s ease-in-out', width: '100%'}}>
                <img src="/products/ATM1.jpg" alt="ATM 탱크" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/ATM2.jpg" alt="ATM 탱크 구조" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
                <img src="/products/ATM3.jpg" alt="ATM 탱크 설치" style={{maxHeight: '300px', flex: '1', minWidth: '100%'}} />
              </div>
              <button className="slider-prev" style={{position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.atm-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-200%)';
                } else if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(0%)';
                } else {
                  container.style.transform = 'translateX(-100%)';
                }
              }}>‹</button>
              <button className="slider-next" style={{position: 'absolute', right: '10px', top: '50%', transform: 'translateY(-50%)', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', padding: '10px', borderRadius: '50%', cursor: 'pointer', zIndex: 2}} onClick={() => {
                const container = document.querySelector('.atm-tank-slider .slider-container');
                const currentTransform = container.style.transform || 'translateX(0%)';
                if (currentTransform === 'translateX(0%)') {
                  container.style.transform = 'translateX(-100%)';
                } else if (currentTransform === 'translateX(-100%)') {
                  container.style.transform = 'translateX(-200%)';
                } else {
                  container.style.transform = 'translateX(0%)';
                }
              }}>›</button>
            </div>

            {/* 장점 */}
            <div className="product-features">
              <h3>▶ 장점 - Advantage</h3>
              <div className="features-text-list">
                <div className="features-column">
                  <div className="feature-text-item">• 대용량 저장 가능 (Large Capacity Storage)</div>
                  <div className="feature-text-item">• 다양한 액체 저장 가능 (Wide Range of Fluids)</div>
                  <div className="feature-text-item">• 구조적 신뢰성 확보 (Reliable Structural Design)</div>
                </div>
                <div className="features-column">
                  <div className="feature-text-item">• 시공 및 유지관리 용이 (Ease of Construction and Maintenance)</div>
                  <div className="feature-text-item">• API 650 등 국제표준 설계 적용 (Compliance with API Standards)</div>
                </div>
              </div>
            </div>
          </section>

        </div>
      </div>
    </>
  );
};

export default Products;









